'use client';

import { usePortalTarget } from './usePortalTarget';

const TOPBAR_ACTIONS_PORTAL_ID = 'topbar-actions-portal';

/** Hueco del topbar donde una vista cuelga sus acciones propias. */
export function useTopbarPortalTarget() {
	return usePortalTarget(TOPBAR_ACTIONS_PORTAL_ID);
}
